import React, {FC, PropsWithChildren} from 'react';

const PANEL_SIZES = {
  md: 'w-[500px]',
  wide: 'w-[720px]',
  lg: 'w-[960px] h-[min(88vh,820px)]',
};

interface OkCancelDialogProps {
  onCancel?: () => void;
  size?: keyof typeof PANEL_SIZES;
}

export const Dialog: FC<PropsWithChildren<OkCancelDialogProps>> = ({children, size = 'md', onCancel = () => {}}) => {
  return (
    <div className="absolute inset-0 flex items-center justify-center z-50 p-4">
      <div
        className="absolute inset-0 opacity-80 bg-black"
        onClick={() => {
          onCancel();
        }}></div>

      <div className={`flex px-5 py-4 ${PANEL_SIZES[size]} max-w-full max-h-[90vh] rounded-lg bg-white text-xl flex-col z-50`}>{children}</div>
    </div>
  );
};
